import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import api from '../../../const/axios'
import MethodologyDialog from './MethodologyDialog'

type Row = {
  entityId: number
  name: string
  city: string
  rating: number
  isActive: boolean
  lastEventDate?: string
  eventsPlayed: number
  isProvisional?: boolean
}

const Ratings: React.FC = () => {
  const [tab, setTab] = useState<'players' | 'teams'>('teams')
  const [city, setCity] = useState('')
  const [age, setAge] = useState('')
  const [category, setCategory] = useState('overall')
  const [active, setActive] = useState<'all' | 'true' | 'false'>('all')
  const [rows, setRows] = useState<Row[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const activeQuery = useMemo(() => {
    if (active === 'all') return undefined
    return active === 'true'
  }, [active])

  const fetchRows = useCallback(async () => {
    setLoading(true)
    setError('')

    try {
      if (tab === 'players') {
        const res = await api.get('/ratings/players', {
          params: {
            city: city || undefined,
            age: age || undefined,
            category: category || undefined,
            active: activeQuery,
          },
        })
        setRows(res.data || [])
      } else {
        const res = await api.get('/ratings/teams', {
          params: {
            city: city || undefined,
            category: category || undefined,
            active: activeQuery,
          },
        })
        setRows(res.data || [])
      }
    } catch (err: any) {
      setError(err?.response?.data || 'Reytinq məlumatları yüklənmədi.')
      setRows([])
    } finally {
      setLoading(false)
    }
  }, [tab, city, age, category, activeQuery])

  useEffect(() => {
    fetchRows()
  }, [fetchRows])

  const inputCls = "border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40"

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-950 pt-16">
      <Helmet>
        <title>NHN Reytinqi | 3sual.az</title>
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-5">

        {/* Hero banner */}
        {/* <div className="rounded-2xl bg-gradient-to-r from-sky-900 via-blue-900 to-indigo-900 text-white p-6 shadow-lg">
          <p className="text-xs uppercase tracking-[0.2em] text-blue-200">Azerbaijan CHGK v2</p>
          <p className="mt-2 text-blue-100 text-sm">Oyunçu və komanda reytinqi, turnir töhfəsi və şəffaf hesablama.</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <MethodologyDialog />
            <Link to="/ratings/admin" className="px-3 py-1.5 rounded-lg bg-amber-300/20 hover:bg-amber-300/30 text-sm text-white transition-colors">
              İdarəetmə Paneli
            </Link>
          </div>
        </div> */}

        {/* Main card */}
        <div className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 dark:border-gray-800 shadow-sm p-4">

          {/* Players / Teams tabs */}
          <div className="flex flex-wrap gap-2 mb-4">
            {/* <button
              onClick={() => setTab('players')}
              className={`px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                tab === 'players'
                  ? 'bg-blue-600 text-white'
                  : 'bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-gray-300 hover:bg-slate-200 dark:hover:bg-gray-700'
              }`}
            >
              Oyunçular
            </button> */}
            {/* <button
              onClick={() => setTab('teams')}
              className={`px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                tab === 'teams'
                  ? 'bg-blue-600 text-white'
                  : 'bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-gray-300 hover:bg-slate-200 dark:hover:bg-gray-700'
              }`}
            >
              Komandalar
            </button> */}
          </div>

          {/* Filters */}
          {/* <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
            <input
              className={inputCls}
              placeholder="Şəhər"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
            {tab === 'players' && (
              <input
                className={inputCls}
                placeholder="Yaş etiketi (məs: junior)"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            )}
            <select
              className={inputCls}
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="overall">Overall</option>
              <option value="open">Open</option>
              <option value="school">School</option>
              <option value="student">Student</option>
              <option value="youth">Youth</option>
            </select>
            <select
              className={inputCls}
              value={active}
              onChange={(e) => setActive(e.target.value as any)}
            >
              <option value="all">Hamısı</option>
              <option value="true">Aktiv</option>
              <option value="false">Qeyri-aktiv</option>
            </select>
            <button
              onClick={fetchRows}
              className="bg-slate-800 hover:bg-slate-700 dark:bg-gray-700 dark:hover:bg-gray-600 text-white rounded-lg px-3 py-2 text-sm font-semibold transition-colors"
            >
              Filtrlə
            </button>
          </div> */}

          {error ? <p className="mt-3 text-sm text-red-500 dark:text-red-400">{error}</p> : null}

          {/* Table */}
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 dark:bg-gray-800/60 border-y border-slate-100 dark:border-gray-700">
                <tr>
                  <th className="text-left px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">#</th>
                  <th className="text-left px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">Ad</th>
                  <th className="text-left px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">Şəhər</th>
                  <th className="text-right px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">Reytinq</th>
                  <th className="text-right px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">Turnir</th>
                  <th className="text-right px-3 py-2.5 text-gray-500 dark:text-gray-400 font-semibold">Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={6} className="text-center px-3 py-10 text-slate-400 dark:text-gray-500">Yüklənir...</td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center px-3 py-10 text-slate-400 dark:text-gray-500">Məlumat tapılmadı</td>
                  </tr>
                ) : (
                  rows.map((r, i) => (
                    <tr
                      key={r.entityId}
                      className="border-b border-slate-100 dark:border-gray-800 hover:bg-slate-50 dark:hover:bg-gray-800/50 transition-colors"
                    >
                      <td className="px-3 py-2.5 text-gray-500 dark:text-gray-400">{i + 1}</td>
                      <td className="px-3 py-2.5">
                        <Link
                          to={tab === 'players' ? `/ratings/players/${r.entityId}` : `/ratings/teams/${r.entityId}`}
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-semibold transition-colors"
                        >
                          {r.name}
                        </Link>
                        {r.isProvisional ? (
                          <span
                            title="Sınaq reytinq: komanda hələ az turnir oynayıb"
                            className="ml-2 inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-400"
                          >
                            P
                          </span>
                        ) : null}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 dark:text-gray-400">{r.city || '-'}</td>
                      <td className="px-3 py-2.5 text-right font-bold tabular-nums text-gray-800 dark:text-gray-100">
                        {Number(r.rating || 0).toFixed(1)}
                      </td>
                      <td className="px-3 py-2.5 text-right text-gray-600 dark:text-gray-400">{r.eventsPlayed || 0}</td>
                      <td className="px-3 py-2.5 text-right">
                        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                          r.isActive
                            ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-400'
                            : 'bg-slate-100 dark:bg-gray-800 text-slate-500 dark:text-gray-400'
                        }`}>
                          {r.isActive ? 'Aktiv' : 'Qeyri-aktiv'}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Ratings
